import { messages } from './messages';

export const ItemSKU = {
  messageDescriptor: messages.itemSKU,
  id: 'item-sku',
};
